





























































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import isMobile from '@/utils/mobile-check';

import ArrowDownIcon from '@/components/icons/Arrow.vue';
import CollapseRowV2 from '@/componentsV2/molecules/CollapseRowV2/CollapseRowV2.vue';
import InfoIcon from '@/components/icons/Info.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';

import BusinessMenuContent from './BusinessMenuContent.vue';
import BillingNetworkTag from '@/componentsV2/atoms/BillingNetworkTag/BillingNetworkTag.vue';
import flagKeys from '@/constants/flagKeys';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import DateUtils from '@/utils/DateUtils';
import { getNeedsOnboardingCall } from '@/utils/onboardingCall';
import { getBillingOnboardingCallPending } from '@/utils/billing';

@Component({
  components: {
    Picture,
    BusinessMenuContent,
    CollapseRowV2,
    ArrowDownIcon,
    BillingNetworkTag,
    Typography,
    InfoIcon
  }
})
export default class BusinessMenu extends Vue {
  @Prop({ default: false }) readonly rootUser: boolean | undefined;
  @Prop({ default: false }) collapsed?: boolean;
  @Prop() notification?: any;

  selectWidth: string | null = null;
  hideFade: boolean = false;
  isMobileDevice = isMobile();

  id = 'business-menu';

  get activeBusiness() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get needsOnboardingCall() {
    return getNeedsOnboardingCall();
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get billingTooltip() {
    if (
      this.billingStatus === EBillingStatusTypes.TO_BE_CANCELED &&
      this.subscription.billingCycle
    )
      return `This business will be part of the Coin Network until the end of the cycle on ${DateUtils.formattedDate(
        {
          date: this.subscription.billingCycle.endAt
        }
      )}.`;
    return 'This business is part of the Coin Network.';
  }

  get startMitingDate() {
    return DateUtils.formattedDate({
      date: this.subscription.nextPaymentAt
    });
  }

  get showBillingDelayedPeriodTag() {
    return (
      this.flags.includes(flagKeys.billingModuleV3) &&
      (this.billingStatus === EBillingStatusTypes.DELAY_PERIOD ||
        getBillingOnboardingCallPending())
    );
  }

  get showBillingTag() {
    return (
      this.flags.includes(flagKeys.billingModuleV2) &&
      (this.billingStatus === EBillingStatusTypes.SUBSCRIBED ||
        this.billingStatus === EBillingStatusTypes.TO_BE_CANCELED ||
        this.billingStatus === EBillingStatusTypes.DELAY_PERIOD ||
        getBillingOnboardingCallPending())
    );
  }

  get billingStatus() {
    return this.activeBusiness.subscriptionStatus;
  }

  get subscription() {
    return this.$store.getters['business/getBillingSubscription'] || {};
  }

  get needsBreakName() {
    if (this.showBillingTag) return this.activeBusiness.name.length >= 15;
    return this.activeBusiness.name.length >= 20;
  }

  handleClickAvatar() {
    if (!this.isMobileDevice) return;
  }

  clickCollapse() {
    this.$emit('click-collapse', this.id);
  }

  updateFade() {
    const elementContainer = this.$refs.container as Element;

    if (!elementContainer) {
      return;
    }

    const elementName = this.$refs.businessName as Element;
    const maxSize = elementContainer.clientWidth - 88;

    this.hideFade = maxSize >= elementName.scrollWidth;
  }

  mounted() {
    this.updateFade();
  }

  @Watch('activeBusiness')
  watchActiveBusiness() {
    this.$nextTick(() => {
      this.updateFade();
    });
  }

  created() {
    window.addEventListener('resize', this.updateFade);
  }

  destroy() {
    window.removeEventListener('resize', this.updateFade);
  }
}
